import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const SUBCATEGORIES = [
  {
    key: "linkedin",
    label: "LinkedIn Ingestion",
    description: "Add, create, or update private company LinkedIn URLs",
    href: "/dashboard/private-companies/linkedin",
    icon: Linkedin,
  },
];

export default function PrivateCompaniesIndex() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Private Companies</h1>
        <p className="text-sm text-muted-foreground">
          Manage private company LinkedIn data
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {SUBCATEGORIES.map((sub) => {
          const Icon = sub.icon;
          return (
            <Link
              key={sub.key}
              to={sub.href}
              className="group flex flex-col rounded-xl border bg-card p-6 transition-all hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mb-1 text-lg font-semibold">{sub.label}</h3>
              <p className="text-sm text-muted-foreground">{sub.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
